/**
 * Client-side RBAC helpers. Mirrors the server roles. The server is
 * authoritative; these are for conditional UI rendering only.
 */

import { useAuth } from "@/store/auth";
import type { UiRole } from "@/types";

/** True if the current session's user is a SuperAdmin. */
export function isSuperAdmin(): boolean {
  return useAuth.getState().user?.role === "super_admin";
}

/** True if the current session is scoped to a single tenant (TenantAdmin). */
export function isTenantAdmin(): boolean {
  return useAuth.getState().user?.role === "tenant_admin";
}

export function isTenantScoped(): boolean {
  const role = useAuth.getState().user?.role;
  return role === "tenant_admin" || role === "tenant_writer" || role === "tenant_reader";
}

export function currentRole(): UiRole | null {
  return useAuth.getState().user?.role ?? null;
}
